export default "__VITE_ASSET__oXjf4xIq__"